import { render, staticRenderFns } from "./Autoplay.vue?vue&type=template&id=0f1814e0"
import script from "./Autoplay.vue?vue&type=script&lang=js"
export * from "./Autoplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f1814e0')) {
      api.createRecord('0f1814e0', component.options)
    } else {
      api.reload('0f1814e0', component.options)
    }
    module.hot.accept("./Autoplay.vue?vue&type=template&id=0f1814e0", function () {
      api.rerender('0f1814e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Autoplay.vue"
export default component.exports